<template>
  <div id="app">
    <router-view />
    <!-- 登录密码过期强制修改弹窗 -->
    <pwd-expired-dialog v-if="token" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PwdExpiredDialog from '@/components/PwdExpiredDialog'

export default {
  name: 'App',
  components: {
    PwdExpiredDialog
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['token'])
  }
}
</script>
<style>
  /* 解决element-ui的table表格控件表头与内容列不对齐问题 */
  .el-table th.gutter{
    display: table-cell!important;
  }
  .el-drawer__header{
    height: 100px;
    padding: 20px;
    margin: 0;
    box-sizing: border-box;
  }
  .el-submenu__title i{
    /* color: white; */
  }
  .header-item {
    margin-bottom: 5px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }
  .header-lebel{
    display: inline-block;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding-right: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 32px;
  }
</style>
